
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry/automotive/whatsapp",
      function () {
        return require("private-next-pages/industry/automotive/whatsapp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industry/automotive/whatsapp"])
      });
    }
  